import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import moment from 'moment-timezone';
function getScheduleText(node) {
    if (!node.intervals) {
        return null;
    }
    if (node.is_open) {
        return `from ${node.intervals.start} - ${node.intervals.end}`;
    }
    const format = 'HH:mm';
    const timestamp = moment.utc(node.timestamp).format(format);
    const actionTime = moment.utc(timestamp, format);
    const startTime = moment.utc(node.intervals.start, format);
    if (actionTime.isBefore(startTime)) {
        return `before ${node.intervals.start}`;
    }
    return `after ${node.intervals.end}`;
}
export function RoutedThroughBusinessHours({ node }) {
    return (_jsxs(_Fragment, { children: ["Business hours \u00B7 ", _jsx("strong", { children: node.is_open ? 'Open' : 'Closed' }), " on", ' ', node.name, " ", getScheduleText(node)] }));
}
